import React from "react";
import Caption from "../components/Library/Caption";
import Embed from "../components/Library/Embed";
import Image from "../components/Library/Image";
import KeepReading from "../components/Library/KeepReading";
import Quote from "../components/Library/Quote";
import QuoteAttribution from "../components/Library/QuoteAttribution";
import styles from "../components/Library/StoryBody/StoryBody.css";

export default {
  "paragraph": <p className={styles.paragraph} />,
  "unstyled": <p className={styles.paragraph} />,
  "unordered-list-item": {
    element: <li className={styles.item} />,
    nest: <ul className={styles.unorderedList} />,
  },
  "ordered-list-item": {
    element: <li className={styles.item} />,
    nest: <ol className={styles.orderedList} />,
  },
  "styled-quote": <Quote styled={true} />,
  "plain-quote": <Quote styled={false} />,
  "quote-attribution": (block, extras) => <QuoteAttribution block={block} extras={extras} />,
  "caption": <Caption />,
  "header-one": <h1 />,
  // header-two needs to be h4 to nest correctly within heading structure for screen readers
  "header-two": <h4 className={styles.subhead} />,
  "header-three": <h3 />,
  "header-four": <h4 />,
  "header-five": <h5 />,
  "header-six": <h6 />,
  "code-block": <pre />,
  "blockquote": <blockquote />,
  "media": <figure />,
  "image": (block) => <Image block={block} />,
  "embed": (block, extras, isClient) => <Embed block={block} isClient={isClient} />,
  "keep-reading": (block, extras) => <KeepReading block={block} extras={extras} />,
  "default": <p className={styles.paragraph} data-unsupported="true" />,
};



// WEBPACK FOOTER //
// ./src/utils/blockHTML.js